import _get from 'lodash/get';

export function selectProducts(state) {
  return _get(state, 'products.products', []);
}

export function selectActiveProduct(state) {
  return _get(state, 'products.activeProduct', {});
}
